import React from 'react';
import { 
  Box, 
  Table, 
  Thead, 
  Tbody, 
  Tr, 
  Th, 
  Td, 
  Button, 
  Text,
  Badge,
  Tooltip
} from '@chakra-ui/react';
import { FaSearch } from 'react-icons/fa';

const SampleContractsList = ({ contracts, onSelectContract, isDisabled }) => {
  if (!contracts || contracts.length === 0) {
    return (
      <Box p={4} borderWidth="1px" borderRadius="md" bg="gray.700">
        <Text color="gray.300" textAlign="center">No sample contracts available</Text>
      </Box>
    );
  }
  
  return (
    <Box overflowX="auto">
      <Table variant="simple" size="sm" colorScheme="whiteAlpha">
        <Thead>
          <Tr>
            <Th color="gray.300">Name</Th>
            <Th color="gray.300">Address</Th>
            <Th color="gray.300">Description</Th>
            <Th color="gray.300">Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {contracts.map((contract, index) => (
            <Tr key={index} _hover={{ bg: 'gray.700' }}>
              <Td>
                <Text fontWeight="bold" color="gray.100">{contract.name}</Text>
                <Badge colorScheme="orange" mt={1}>Demo</Badge>
              </Td>
              <Td>
                <Tooltip label={contract.address}>
                  <Text color="gray.300">{`${contract.address.substring(0, 6)}...${contract.address.substring(38)}`}</Text>
                </Tooltip>
              </Td>
              <Td color="gray.300">{contract.description}</Td>
              <Td>
                <Button
                  size="xs"
                  colorScheme="blue"
                  leftIcon={<FaSearch />}
                  onClick={() => onSelectContract(contract.address)}
                  isDisabled={isDisabled}
                >
                  Scan
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default SampleContractsList; 